const  Data = [
    {
        "heading": "CABLE GLAND",
        "title": "Brass Stopping Plug",
        "image": "/images/category-images/cable-gland/BRASS STOPPING PLUC.jpg",
        "link": "/category/cables/brass-stopping-plug"
    },
    {
        "heading": "CABLE GLAND",
        "title": "Extension Piece",
        "image": "https://lntsufin.com/storage/mediafiles/catalog/live/16691-10037/original/16691-10037_image_0.jpg",
        "link": "/category/cables/extension-piece"
    },
    {
        "heading": "CABLE GLAND",
        "title": "PG Brass Cable Glands Nickle Plated",
        "image": "https://c8.alamy.com/comp/2AAT8PY/sanitary-faucets-isolated-on-white-background-material-nickel-plated-brass-2AAT8PY.jpg",
        "link": "/category/cables/pg-brass-cable-gland"
    },
    {
        "heading": "CABLE GLAND",
        "title": "Earthing Tag",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/cables/earthing-tag"
    },
    {
        "heading": "CABLE GLAND",
        "title": "Lock Nut",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/cables/lock-nut"
    },
    {
        "heading": "CABLE GLAND",
        "title": "Brass Reducers",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/cables/brass-reducers"
    },
    {
        "heading": "CABLE GLAND",
        "title": "Line Taps / Split Bolt",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/cables/line-taps"
    },
    {
        "heading": "CABLE GLAND",
        "title": "Split Bolt Connector with Round Head",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/cables/split-bolt-connector"
    },



    // senitary parts

    {
        "heading": "SANITARY PARTS",
        "title": "Hex Nipple",
        "image": "/images/category-images/Sanitary Parts/hex nipple 1.jpg",
        "link": "/category/sanitary/hex-nipple"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "UNION",
        "image": "/images/category-images/Sanitary Parts/UNION 1.jpg",
        "link": "/category/sanitary/union"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Reducing Bush",
        "image": "/images/category-images/Sanitary Parts/reducing bush.jpg",
        "link": "/category/sanitary/reducing-bush"
    },
    // {
    //     "heading": "SANITARY PARTS",
    //     "title": "Socket / Coupling Hex & Round",
    //     "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
    //     "link": "/category/sanitary/socket-round"
    // },
    {
        "heading": "SANITARY PARTS",
        "title": "ROUND FLANGE TANK CONNECTOR SINGLE SIDE MOVE",
        "image": "/images/category-images/Sanitary Parts/ROUND FLANGE TANK CONNECTOR SINGLE SIDE MOVE.jpg",
        "link": "/category/sanitary/round-flange-tank-connector-single-side-move"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "TANK CONNECTOR DOUBLE-SIDE MOVE",
        "image": "/images/category-images/Sanitary Parts/TANK CONNECTOR DOUBLE SIDE MOVE.jpg",
        "link": "/category/sanitary/tank-connector-double-side-move"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Water Meter Connector",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/water-meter-connctor"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Tee Coupling",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/tee-coupling"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Elbow Coupling",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/elbow-coupling"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Kim Nipple",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/kim-nipple"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Male Plug",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/male-plug"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Female Plug",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/female-plug"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Hose Nipple",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/hose-nipple"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "LONG NIPPLE",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/long-nippple"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "CP Socket",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/cp-socket"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "Brass Nut",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/brass-nut"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "CP Cross Tee",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/cp-cross-tee"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "CP Male Female Elbow (Collar)",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/cp-male-female-elbow"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "CP Hex Nipple",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/cp-hex-nipple"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "CP Hex Cap Female",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/cp-hex-cap-female"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "CP Plug Male & Female",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/cp-plug-male-female"
    },
    {
        "heading": "SANITARY PARTS",
        "title": "CP Waste Coupling",
        "image": "https://probots.co.in/pub/media/catalog/product/cache/d8ddd0f9b0cd008b57085cd218b48832/p/g/pg_13.5_metal.jpg",
        "link": "/category/sanitary/cp-waste-coupling"
    }
]

export default Data;